import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { gql } from "@apollo/client";
export const typeDef = gql`
  type MetaTags {
    robots: String
    title: String
    keywords: String
    description: String
    canonicalUrl: String
  }

  type WebPage @cacheControl(maxAge: 300) {
    id: Int
    content: String
    style: String
    script: String
    metatags: MetaTags
  }

  type Query {
    webPage(path: String): WebPage
  }
`;
export const resolvers = {
  Query: {
    webPage: async (_parent, args, _ref) => {
      let {
        dataSources
      } = _ref;
      const res = await dataSources.webPage.getPage(args.path);
      return _objectSpread(_objectSpread({}, res), {}, {
        metatags: _objectSpread({
          robots: res.robots,
          canonicalUrl: res.canonical_url
        }, res.values)
      });
    }
  }
};